import Grid from "../widgets/grid/grid.vue";
import Restful from '../../assets/ts/restful';

export default {
    props: [
    ],
    data() {
        var that = this;
        reloadGridCartabl = function () {
            that.reLoadeData();
            debugger;
        };
        var userColumnName = this.$route.params.isReceivedMessage === "true" ? this.$t("message_management.sender") : this.$t("message_management.receiver");
        return {
            boldOnField: "IsDisplayed",
            direction: payload.currentLocale.IsRightToLeft,
            columns: [
                { field: "Id", title: this.$t('id'), menu: false, hidden: true },

                {
                    field: "Subject", title: this.$t("message_management.subject"), filterable: false, sortable: false,
                    template: (dataItem) => {

                        var result = "<a class='timeago subj' href='" + window.location.pathname + "#/view-message/" + dataItem.Id + "/" + this.$route.params.isReceivedMessage + "' title='" + dataItem.Subject + "'>" + dataItem.Subject + "</a>";
                        return result;
                    }
                },

                {
                    field: "UserTitle", title: userColumnName, filterable: false, sortable: false,
                    width: 76,
                    minScreenWidth: 500

                },
                {
                    field: "CreatedAt_Persian", title: this.$t("message_management.date_time_send"), filterable: false, sortable: false, width: 120,
                    template: (dataItem) => {
                        return $.timeago(dataItem.CreatedAt_Persian);
                        //return dataItem.CreationDate;
                    }
                },
                { field: "IsDisplayed", title: "", filterable: false, sortable: false, hidden: true }
            ],
            toolbar: '',
            reloadGrid: 0,
            schema: {
                data: "d.Data",
                total: function (response) { return response.d.Total; },
                aggregates: "d.Aggregates"
            }
        };
    },
    watch: {
        '$route'(to, from) {
            this.getGridColumns();
        }
    },
    computed: {
        additionalParameters() {
            this.reloadGrid++;
            return {
                ReceivedMessage: this.$route.params.isReceivedMessage

            }
        },
        title: function () {
            if (this.$route.params.isReceivedMessage === "true") {
                return this.$t('messages_receive');
            }
            return this.$t('messages_sent');
        }
    },
    methods: {
        taskEventCallBack() {
            if (payload.IsPlugin) {
                debugger;
                window.bpmsClose('');
                return;
            }
            this.reLoadeData();
        },
        getGridColumns() {
            debugger;
            var userColumnName = this.$route.params.isReceivedMessage === "true" ? this.$t("message_management.sender") : this.$t("message_management.receiver"); 
            this.columns = [
                { field: "Id", title: this.$t('id'), menu: false, hidden: true },

                {
                    field: "Subject", title: this.$t("message_management.subject"), filterable: false, sortable: false,
                    template: (dataItem) => {

                        var result = "<a class='timeago subj' href='" + window.location.pathname + "#/view-message/" + dataItem.Id + "/" + this.$route.params.isReceivedMessage + "' title='" + dataItem.Subject + "'>" + dataItem.Subject + "</a>";
                        return result;
                    }
                },

                {
                    field: "UserTitle", title: userColumnName, filterable: false, sortable: false,
                    width: 76,
                    minScreenWidth: 500

                },
                {
                    field: "CreatedAt_Persian", title: this.$t("message_management.date_time_send"), filterable: false, sortable: false, width: 120,
                    template: (dataItem) => {
                        return $.timeago(dataItem.CreatedAt_Persian);
                        //return dataItem.CreationDate;
                    }
                },
                { field: "IsDisplayed", title: "", filterable: false, sortable: false, hidden: true }
            ];
        },
        reLoadeData() {
            this.reloadGrid++;
        },
        doAjaxRequest(url, data, onSuccess, onFailure, method) {
            let ajaxConfig = {
                url: url,
                data: data,
                dataType: "json",

                contentType: "application/json;charset=utf-8"
            };
            if (method) {
                ajaxConfig.method = method;
            }
            $.ajax(ajaxConfig)
                .done((result) => {
                    if (typeof onSuccess === 'function')
                        onSuccess(result);
                }).error((error) => {
                    console.log(error);
                    if (typeof onFailure === 'function')
                        onFailure();
                });
        }
    },
    updated() {
    },
    mounted() {
    },
    components: {
        Grid
    }
}
